import React from "react";
import "../styles/HeroSection.css";

function HeroSection() {
    return (
        <div className="video-section">
            {/* Video Background */}
            <video className="background-video" autoPlay loop muted playsInline>
                <source src="/videos/sol.mp4" type="video/mp4"/>
                Your browser does not support the video tag.
            </video>
            {/* Overlay Content */}
            <div className="video-overlay">
                <p className="welcome-text">Welcome To</p>
                <h1 className="landing-title">Sol Cafe Lounge</h1>
                <p className="tagline">Your destination for luxury and unforgettable moments</p>
            </div>
        </div>
    );
}

export default HeroSection;
